import React from "react";
import { Link } from "react-router-dom";

const SinglePage = () => {
  return (
    <>
      <main>
        <section className="hero">
          <div className="container hero-content">
            <div className="row align-items-end g-4">
              <div className="col-lg-8">
                <div className="eyebrow" style={{ color: "#ffb4a7" }}>
                  Mohan Alcoves · Badlapur West · Thane
                </div>
                <h1>Thoughtfully planned homes for modern living.</h1>
                <p>
                  Mohan Alcoves is an under-construction residential project by
                  Mohan Group, offering 1 BHK and 2 BHK apartments at Valivali,
                  Manjarli, Badlapur West.
                </p>
                <div className="hero-meta">
                  <span className="pill">1 BHK</span>
                  <span className="pill">2 BHK</span>
                  <span className="pill">385-548 sq.ft.</span>
                  <span className="pill">Possession: June 2029</span>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="hero-card">
                  <strong>Mohan Alcoves</strong>
                  <span>Valivali, Manjarli, Badlapur West, Thane</span>
                  <div className="price">RERA · P51700053525</div>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#enquiryModal"
                  >
                    Enquire Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="trust">
          <div className="container">
            <div className="row row-cols-2 row-cols-md-4 g-3 trust-row">
              <div className="col">
                <div className="trust-item">
                  <b>1987</b>
                  <span>Mohan Group established</span>
                </div>
              </div>
              <div className="col">
                <div className="trust-item">
                  <b>43</b>
                  <span>Real estate projects developed</span>
                </div>
              </div>
              <div className="col">
                <div className="trust-item">
                  <b>1 &amp; 2</b>
                  <span>BHK configurations</span>
                </div>
              </div>
              <div className="col">
                <div className="trust-item">
                  <b>Jun 2029</b>
                  <span>Expected possession</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section overview" id="overview">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow">The Project</div>
              <h2>About Mohan Alcoves</h2>
              <p>
                Mohan Alcoves is a residential project by Mohan Group in Thane,
                located in Badlapur West and designed for modern homebuyers.
              </p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4">
                <div className="project-card">
                  <div className="logo-box">
                    <img
                      src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                      alt="Mohan Alcoves project view"
                    />
                  </div>
                  <h3>Project View</h3>
                  <span className="rera">RERA ID: P51700053525</span>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="copy">
                  <p>
                    Mohan Alcoves is an under-construction project located in{" "}
                    <strong>Badlapur West</strong>, offering thoughtfully
                    designed apartments for modern homebuyers. The project
                    offers <strong>1 BHK and 2 BHK apartments</strong>, with
                    units ranging from <strong>385.0 to 548.0 sq.ft.</strong> as
                    per the area plan.
                  </p>
                  <p>
                    Launched in <strong>November 2023</strong>, Mohan Alcoves is
                    slated for possession in
                    <strong>June 2029</strong>. The project is located at{" "}
                    <strong>Valivali, Manjarli, Badlapur West</strong>, a
                    residential locality in Thane.
                  </p>
                  <p>
                    Mohan Alcoves ensures a convenient lifestyle with provisions
                    including energy management, landscaping and tree planting,
                    solid waste management and disposal, storm water drains, and
                    a sewage treatment plant. There is also provision for closed
                    car parking.
                  </p>
                  <p>
                    The project is RERA compliant, with RERA ID P51700053525.
                    For those looking for 1 BHK or 2 BHK apartments in Badlapur
                    West, Mohan Alcoves offers a range of residential options
                    within a thoughtfully planned development.
                  </p>
                  <div className="specs row row-cols-1 row-cols-sm-2 g-0">
                    <div className="col spec">
                      <label>Location</label>
                      <strong>Valivali, Manjarli, Badlapur West, Thane</strong>
                    </div>
                    <div className="col spec">
                      <label>Configuration</label>
                      <strong>1 BHK &amp; 2 BHK</strong>
                    </div>
                    <div className="col spec">
                      <label>Area</label>
                      <strong>385.0-548.0 sq.ft.</strong>
                    </div>
                    <div className="col spec">
                      <label>Launch</label>
                      <strong>November 2023</strong>
                    </div>
                    <div className="col spec">
                      <label>Possession</label>
                      <strong>June 2029</strong>
                    </div>
                    <div className="col spec">
                      <label>Project Status</label>
                      <strong>Under Construction</strong>
                    </div>
                    <div className="col spec">
                      <label>RERA ID</label>
                      <strong>P51700053525</strong>
                    </div>
                    <div className="col spec">
                      <label>Parking</label>
                      <strong>Closed car parking provision</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section group" id="group">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow">The Developer</div>
              <h2>About Mohan Group</h2>
              <p>
                Established in 1987, Mohan Group is a real estate developer in
                Thane offering value-for-money solutions across residential and
                commercial segments.
              </p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4">
                <div className="copy">
                  <p>
                    With residential projects in Thane and Badlapur, the group
                    focuses on developing spacious and convenient homes while
                    maintaining affordability, design, quality, and timely
                    delivery.
                  </p>
                  <p>
                    Till date, Mohan Group has developed 43 real estate projects
                    , with a focus on creating healthy and sustainable
                    lifestyles. The developer carefully selects locations with
                    growth potential and follows strict quality standards across
                    its developments.
                  </p>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="project-card">
                  <div className="developer-stats row row-cols-2 g-3">
                    <div className="col">
                      <div className="dev-stat">
                        <strong>1987</strong>
                        <span>Established</span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="dev-stat">
                        <strong>43</strong>
                        <span>Projects developed</span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="dev-stat">
                        <strong>ISO 9001:2008</strong>
                        <span>Certification</span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="dev-stat">
                        <strong>ISO 14001:2004</strong>
                        <span>Certification</span>
                      </div>
                    </div>
                  </div>
                  <div className="copy">
                    <p>
                      Mohan Group's portfolio includes residential and
                      commercial properties in Thane , catering to different
                      requirements of homebuyers and investors. The company is
                      guided by its emphasis on hard work and honesty and holds{" "}
                      ISO 9001:2008 and ISO 14001:2004 certifications ,
                      supporting its commitment to quality and reliability.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="section amenities" id="amenities">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow">Project Amenities</div>
              <h2>Convenience built into the development.</h2>
              <p>
                Mohan Alcoves includes provisions designed to support a
                convenient and thoughtfully planned residential environment.
              </p>
            </div>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3">
              <div className="col">
                <div className="amenity">
                  <div className="icon">01</div>
                  <h4>Energy Management</h4>
                  <p>Provision for energy management across the development.</p>
                </div>
              </div>
              <div className="col">
                <div className="amenity">
                  <div className="icon">02</div>
                  <h4>Landscaping &amp; Tree Planting</h4>
                  <p>
                    Planned landscaping and tree planting within the project.
                  </p>
                </div>
              </div>
              <div className="col">
                <div className="amenity">
                  <div className="icon">03</div>
                  <h4>Solid Waste Management &amp; Disposal</h4>
                  <p>Provision for solid waste management and disposal.</p>
                </div>
              </div>
              <div className="col">
                <div className="amenity">
                  <div className="icon">04</div>
                  <h4>Storm Water Drains</h4>
                  <p>Storm water drainage infrastructure within the project.</p>
                </div>
              </div>
              <div className="col">
                <div className="amenity">
                  <div className="icon">05</div>
                  <h4>Sewage Treatment Plant</h4>
                  <p>
                    A sewage treatment plant is provided as part of the
                    development.
                  </p>
                </div>
              </div>
              <div className="col">
                <div className="amenity">
                  <div className="icon">06</div>
                  <h4>Closed Car Parking</h4>
                  <p>Provision for closed car parking for residents.</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section className="section plans" id="plans">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow">Designed for your life</div>
              <h2>Layouts &amp; floor plans.</h2>
              <p>
                Explore the available layout and floor plan visuals for Mohan
                Alcoves.
              </p>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-3">
              <div className="col">
                <div className="plan">
                  <img
                    src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                    alt="Mohan Alcoves floor plan"
                  />
                  <div className="plan-caption">
                    <strong>Floor Plan</strong>
                    <span>VIEW PLAN →</span>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="plan">
                  <img
                    src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                    alt="Mohan Alcoves layout plan"
                    style={{ objectPosition: "right" }}
                  />
                  <div className="plan-caption">
                    <strong>Layout &amp; Floor Plan</strong>
                    <span>VIEW PLAN →</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section gallery" id="gallery">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow">Inside &amp; outside</div>
              <h2>Gallery</h2>
              <p>
                Live your life surrounded by impeccably designed green spaces
                that take you towards serenity and away from the toil of stress.
                Get ready to level up your home entertainment with us.
              </p>
            </div>
            <div className="gallery-grid">
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves exterior"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves towers"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves view"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves building"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves amenities"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves landscape"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves exterior view"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves pool and recreation"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves community space"
                />
              </div>
              <div className="gallery-item">
                <img
                  src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                  alt="Mohan Alcoves residence"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="section location" id="location">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow" style={{ color: "#ff9d8d" }}>
                Connected living
              </div>
              <h2>Find Mohan Alcoves.</h2>
              <p>
                Located at Valivali, Manjarli, Badlapur West, a residential
                locality in Thane.
              </p>
            </div>
            <div className="row g-3">
              <div className="col-lg-8">
                <div className="map">
                  <img
                    src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                    alt="Mohan Alcoves location map"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="address">
                  <div>
                    <div className="pin">⌖</div>
                    <h3>Project Address</h3>
                    <p>
                      Valivali, Manjarli,
                      <br />
                      Badlapur West, Thane,
                      <br />
                      Maharashtra.
                    </p>
                  </div>
                  <div>
                    <span className="eyebrow" style={{ color: "#ff9d8d" }}>
                      Badlapur (W)
                    </span>
                    <p>
                      RERA ID: P51700053525
                      <br />
                      Possession: June 2029
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section brochure" id="brochure">
          <div className="container">
            <div className="brochure-box row g-4 align-items-center">
              <div className="col-lg-7">
                <div className="eyebrow">Project details, in one place</div>
                <h2>Take Mohan Alcoves with you.</h2>
                <p>
                  Within our brochure, each and every detail about our project
                  has been highlighted in clear and precise terms, ensuring that
                  you make the perfect choice for your future when you choose
                  your home with us.
                </p>
                <Link
                  to="/"
                  className="download"
                  data-bs-toggle="modal"
                  data-bs-target="#enquiryModal"
                >
                  DOWNLOAD BROCHURE ↓
                </Link>
              </div>
              <div className="col-lg-5">
                <div className="brochure-image">
                  <img
                    src="https://mohan-group.com/images/projects/mohan-alcoves/banner.jpg"
                    alt="Mohan Alcoves brochure"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pop Up */}
        <div
          className="modal fade"
          id="enquiryModal"
          tabIndex={-1}
          aria-labelledby="enquiryModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body p-4">
                <button
                  type="button"
                  className="btn-close position-absolute top-0 end-0 m-3"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
                <div id="modalFormWrap">
                  <h3 className="modal-box-title" id="enquiryModalLabel">
                    Get project details
                  </h3>
                  <p className="modal-sub">
                    Share your details and our team will get in touch with
                    pricing, floor plans and the brochure for Mohan Alcoves.
                  </p>
                  <form
                    className="modal-form"
                    id="enquiryForm"
                    onsubmit="return handleEnquirySubmit(event)"
                  >
                    <div className="mb-3">
                      <label htmlFor="enqName" className="form-label d-block">
                        Name
                      </label>
                      <input
                        type="text"
                        id="enqName"
                        name="name"
                        className="form-control"
                        placeholder="Your full name"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="enqMobile" className="form-label d-block">
                        Mobile
                      </label>
                      <input
                        type="tel"
                        id="enqMobile"
                        name="mobile"
                        className="form-control"
                        placeholder="10-digit mobile number"
                        pattern="[0-9+ ]{10,15}"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="enqEmail" className="form-label d-block">
                        Email
                      </label>
                      <input
                        type="email"
                        id="enqEmail"
                        name="email"
                        className="form-control"
                        placeholder="info@homesdekho.com"
                        required
                      />
                    </div>
                    <button type="submit" className="w-100">
                      Submit
                    </button>
                    <p className="modal-note">
                      By submitting, you agree to be contacted about this
                      project.
                    </p>
                  </form>
                </div>
                <div className="modal-success" id="modalSuccess">
                  <div className="tick">✓</div>
                  <h3 className="modal-box-title text-center">Thank you!</h3>
                  <p className="modal-sub text-center">
                    We've received your details. Our team will reach out to you
                    shortly with more information on Mohan Alcoves.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default SinglePage;
